:host {
  display: block;
  max-width: 100%;
  --switch-height: 32px;
  --switch-border-radius: 16px;
  --label-width: 50%;
  --container-width: 100%;
}

:host([disabled]) {
  pointer-events: none;

  input[type='radio'].toggle {
    &:checked + label {
      cursor: default;
      border-color: var(--grey-layout-200-disabled);
      gz-text {
        color: var(--grey-layout-200-disabled);
      }
    }

    & + label {
      cursor: default;
      gz-text {
        color: var(--grey-layout-200-disabled);
      }
    }

    &:not(:checked) + label {
      &:hover {
        opacity: 1;
      }
    }
  }
}

.container,
label {
  display: inline-flex;
  align-items: center;
  border-radius: var(--switch-border-radius);
}

.container {
  background-color: var(--chart-050-hover);
  max-width: 100%;
  max-height: var(--switch-height);
  width: var(--container-width);
}

label {
  border: 1px solid transparent;
  padding: var(--spacer) calc(var(--spacer) * 2);
  position: relative;
  width: var(--label-width);
  justify-content: center;

  gz-text {
    transition: color 600ms ease;
  }
}

gz-text {
  display: inline;
}

gz-tooltip {
  display: inline;
  line-height: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

input[type='radio'].toggle {
  display: none;

  & + label {
    cursor: pointer;

    max-height: var(--switch-height);

    gz-text {
      color: var(--chart-300-icon-buttons);
    }

    &:hover {
      background: none;
      color: var(--body-text-arrows-400);
    }
  }

  &:not(:checked) + label {
    &:hover {
      opacity: 0.7;
    }
  }

  &.toggle-left + label {
    border-right: 0;
  }

  &.toggle-right + label {
    margin-left: -5px;
  }

  &:checked + label {
    background-color: var(--active-background-color, var(--chart-050-hover));
    border: 1px solid var(--active-border-color, var(--body-text-arrows-400));
    cursor: default;

    gz-text {
      color: var(--active-text-color, var(--body-text-arrows-400));
      transition: color 200ms;
    }
  }
}
